import {asUuid} from 'shared/utils/types-utils';

export const RECORD_COLLECTION_CATEGORY_ID = {
    FAVOURITES: asUuid('005e8650-3e13-4c02-ba6c-a46d680d4bf1'),
    PRIVATE: asUuid('99715646-f0c0-4607-bcb6-924abbe733cb'),
    OTHER: asUuid('b0a41fbc-1724-4ebd-aa9d-3e64d9308173'),
} as const;